import MarketingNavbar from "./MarketingNavbar";
import MarketingFooter from "./MarketingFooter";

/**
 * Consistent shell for all marketing / public pages.
 * Includes premium enterprise background layer + top nav + footer.
 */
export default function MarketingLayout({ children }) {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100 antialiased">
      <MarketingNavbar />
      <main className="pt-16">{children}</main>
      <MarketingFooter />
    </div>
  );
}
